import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { PaymentChannelEventContainerModel } from "../../../../../models/aggregates/pgw/payment-channel-event.model";
import {
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
  PagingResponseModel,
} from "../shared";
import {
  PaymentChannelEventQueryCriteriaClass,
  PaymentChannelEventCriteriaModelQuery,
} from "../../criteria/pgw/payment-channel-event-criteria.model";

@Injectable({
  providedIn: "root",
})
export class PaymentChannelEventService extends BaseApiTemplateService<PaymentChannelEventContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + "paymentchannels/events";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + "paymentchannels/events";
    this.httpClient = http;
  }

  getPaymentChannelByCriteria(
    visa: ApiVisa,
    criteria?: PaymentChannelEventQueryCriteriaClass
  ): Observable<PagingResponseModel<PaymentChannelEventContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const buildPaymentChannelCriteriaCriteria = new PaymentChannelEventCriteriaModelQuery(criteria);
    console.log("query", buildPaymentChannelCriteriaCriteria.query);
    return this.httpClient.get<PagingResponseModel<PaymentChannelEventContainerModel>>(
      this.apiUrl + "/query?" + buildPaymentChannelCriteriaCriteria.query,
      this.getHttpHeader(visa)
    );
  }
}
